import type { Identifiable } from '../../shared/types'
import z from 'zod'
import { Identifier } from '../../shared/types'

// Cart
export const CreateCartBodySchema = z.object({
  userId: Identifier,
})
export type CreateCartBody = z.infer<typeof CreateCartBodySchema>
export type CartDto = Identifiable<CreateCartBody> & {
  skus?: CartSkuDto[]
  bundles?: CartBundleDto[]
  subscriptions?: CartSubscriptionDto[]
  promotions?: CartPromotionDto[]
}

export const LatestCartDtoSchema = z.object({
  cartId: z.string().uuid(),
  userId: z.string().uuid(),
})
export type LatestCartDto = z.infer<typeof LatestCartDtoSchema>

export const UpsertCartSkuBodySchema = z.object({
  quantity: z.number().int().positive(),
})
export type UpsertCartSkuBody = z.infer<typeof UpsertCartSkuBodySchema>

export type CartSkuDto = UpsertCartSkuBody & {
  id: string;
  productVariantId: string
}

// Bundle
export const CreateCartBundleBodySchema = z.object({})
export type CreateCartBundleBody = z.infer<typeof CreateCartBundleBodySchema>
export type CartBundleDto = Identifiable<CreateCartBundleBody> & {
  skus: CartSkuDto[]
  cartId: string
  subscriptionId?: string
}

// Subscription
export const CreateCartSubscriptionBodySchema = z.strictObject({})
export type CreateCartSubscriptionBody = z.infer<typeof CreateCartSubscriptionBodySchema>
export type CartSubscriptionDto = Identifiable<CreateCartSubscriptionBody> & {
  skus: CartSkuDto[]
  bundles: CartBundleDto[]
  animalPlans: Record<string, CartAnimalFeedingPlanDto[]>
  sharedPlans: CartSharedFeedingPlanDto[]
  cartId: string
}

// Plan
export const CreateCartFeedingPlanBodySchema = z.object({
  planId: Identifier,
  animalId: Identifier.optional().nullable(),
  orderLimit: z.number().positive().optional(),
})
export type CreateCartFeedingPlanBody = z.infer<typeof CreateCartFeedingPlanBodySchema>

export const UpdateCartFeedingPlanBodySchema = CreateCartFeedingPlanBodySchema.partial()
export type UpdateCartFeedingPlanBody = z.infer<typeof UpdateCartFeedingPlanBodySchema>

export type CartFeedingPlanDto = Identifiable<CreateCartFeedingPlanBody> & {
  position: number
  cartId: string
  subscriptionId: string
  products?: CartFeedingPlanProductDto[]
  skus?: CartSkuDto[]
}
export type CartAnimalFeedingPlanDto = Omit<CartFeedingPlanDto, 'skus'> & {
  animalId: string
  products: CartFeedingPlanProductDto[]
}
export type CartSharedFeedingPlanDto = Omit<CartFeedingPlanDto, 'animalId' | 'products'> & {
  skus: CartSkuDto[]
}

// PlanProduct
export const CreateCartFeedingPlanProductBodySchema = z.object({
  productId: Identifier,
})
export type CreateCartFeedingPlanProductBody = z.infer<typeof CreateCartFeedingPlanProductBodySchema>
export type CartFeedingPlanProductDto = z.infer<typeof CreateCartFeedingPlanProductBodySchema>

// Promotion
export const AddPromotionToCartBodySchema = z.object({
  discountId: z.string().uuid().optional().nullable(),
})
export type AddPromotionToCartBody = z.infer<typeof AddPromotionToCartBodySchema>
export interface CartPromotionDto {
  promotionId: string
  discountId: string | null
  cartId: string
}
